// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"47b76421","787":"c869edfb"}[chunkId] + ".chunk.js";
};